

/**
 * Log condizionale, viene comandato dalla costante DEBUG
 * @param msg
 */
export let showlog = (...msg) => {
	// if( !!DEBUG || !!window.DEBUG ) console.log.apply( console, msg );
	console.log.apply( console, msg );
};



export const renderlog = (
	componentName,
	state,
	props,
	colorPolicy = { color: "#3388ff", contrastColor: "#ffffff" }
) => {

	showlog(
		"%c RENDER %c "+ componentName +" ",
		"background: "+ colorPolicy.color +"; color: "+ colorPolicy.contrastColor +"; border-radius:3px 0px 0px 3px; padding:3px; font-weight: bold;",
		"background: "+ colorPolicy.color +"88; color: "+ colorPolicy.contrastColor +"; border-radius:0px 3px 3px 0px; padding:3px;"
	);
	showlog( "state", state );
	showlog( "props", props );
}


// export const errorlog = (message, e) => {
// 	showlog(
// 		// "%c"+ emoj(EMOJ.face_with_symbols_on_mouth) +" errore %c "+ message.toUpperCase() +" ",
// 		"%c"+ emoj(EMOJ.face_screaming_in_fear) +" errore %c "+ message.toUpperCase() +" ",
// 		"color: "+ COLOR_POLICY.error.color +"; font-size: 20px;",
// 		"background: "+ COLOR_POLICY.error.color +"; color: "+ COLOR_POLICY.error.contrastColor +"; border-radius:3px 3px 3px 3px; padding:3px; font-weight: bold; font-size: 20px;"
// 	);
// 	showlog( e );
// }

/**
 * fa il log in console dela stringa formattata dell'oggetto passato
 * @param obj
 */
export const beautifyLog = obj => {
	showlog( beautify( obj ) );
};

/**
 * Da la stringa formattata dell'oggetto passato
 * @param obj
 * @returns {string}
 */
export const beautify = obj => {
	return JSON.stringify( obj, null, "\t");
};
